module.exports = __webpack_public_path__ + "static/media/Inter-Medium.91d58902.woff2";